// extracted by mini-css-extract-plugin
export default {"cardsGrid":"ScratchCodesLayout_cardsGrid__8YaAc"};